import { render, staticRenderFns } from "./AddAttrValue.vue?vue&type=template&id=bab129ea&scoped=true"
import script from "./AddAttrValue.vue?vue&type=script&lang=js"
export * from "./AddAttrValue.vue?vue&type=script&lang=js"
import style0 from "./AddAttrValue.vue?vue&type=style&index=0&id=bab129ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab129ea",
  null
  
)

export default component.exports